var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role == "account"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("span", { staticClass: "alert-danger" }, [
            _vm._v("У вас нет доступа к этой странице.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role !== "account"
      ? _c(
          "div",
          { staticClass: "main-content bg-white dataPage" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col lg-12" },
                [
                  _c(
                    "b-alert",
                    {
                      attrs: { variant: "danger", dismissible: "" },
                      model: {
                        value: _vm.showDismissibleAlert,
                        callback: function($$v) {
                          _vm.showDismissibleAlert = $$v
                        },
                        expression: "showDismissibleAlert"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.alertText))])]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      attrs: { variant: "success", dismissible: "" },
                      model: {
                        value: _vm.showSuccessAlert,
                        callback: function($$v) {
                          _vm.showSuccessAlert = $$v
                        },
                        expression: "showSuccessAlert"
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.successAlertText))])]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                    [
                      _c(
                        "b-btn",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.createData",
                              modifiers: { createData: true }
                            }
                          ],
                          staticClass: "mainButton filterComponent",
                          staticStyle: { "white-space": "nowrap" },
                          attrs: { size: "sm", variant: "success" }
                        },
                        [
                          _vm._v(
                            "\n                    Добавить данные\n                    "
                          ),
                          _c("i", { staticClass: "icon-fa icon-fa-pencil" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                    [
                      _c(
                        "b-btn",
                        {
                          staticClass: "mainButton filterComponent",
                          staticStyle: { "white-space": "nowrap" },
                          attrs: { size: "sm", variant: "success" },
                          on: { click: _vm.addTable }
                        },
                        [
                          _vm._v(
                            "\n                    Добавить данные\n                    "
                          ),
                          _c("i", { staticClass: "icon-fa icon-fa-pencil" })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMobile
                ? _c(
                    "div",
                    { staticClass: "col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2" },
                    [
                      _c(
                        "b-button-group",
                        {
                          staticClass: "filterComponent",
                          staticStyle: { width: "100%!important" }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "success", size: "sm" },
                              on: { click: _vm.selectAllRows }
                            },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-check-square-o"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "danger", size: "sm" },
                              on: { click: _vm.unselectAllRows }
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-close" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "primary", size: "sm" },
                              on: { click: _vm.changeLeadRate }
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-edit" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-1",
                              attrs: { variant: "warning", size: "sm" },
                              on: {
                                click: function($event) {
                                  return _vm.copySelected()
                                }
                              }
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-copy" })]
                          ),
                          _vm._v(" "),
                          _vm.$currentUser.role === "admin"
                            ? _c(
                                "b-button",
                                {
                                  attrs: { variant: "info", size: "sm" },
                                  on: { click: _vm.openDataUploadModal }
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-upload"
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _vm.isXl
                    ? _c(
                        "b-button-group",
                        {
                          key: _vm.dateRange,
                          staticClass: "filterComponent datePickerXl"
                        },
                        [
                          _c("date-range-picker", {
                            ref: "picker",
                            attrs: {
                              "locale-data": _vm.dateRangeLocalFormat,
                              opens: "center",
                              ranges: _vm.dateRanges
                            },
                            on: {
                              update: function($event) {
                                return _vm.selectRange($event)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function(picker) {
                                    return [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.startDate
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.range.endDate
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "header",
                                  fn: function(header) {
                                    return _c("div", { staticClass: "slot" }, [
                                      _c("h2", [
                                        _vm._v("Выбрать даты создания данных")
                                      ])
                                    ])
                                  }
                                }
                              ],
                              null,
                              false,
                              1844219209
                            ),
                            model: {
                              value: _vm.range,
                              callback: function($$v) {
                                _vm.range = $$v
                              },
                              expression: "range"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            { attrs: { size: "sm", variant: "primary" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-calendar-check-o"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isXl
                    ? _c(
                        "b-input-group",
                        { key: _vm.dateRange, staticClass: "filterComponent" },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c("datepicker", {
                                staticClass: "date dateLeft",
                                staticStyle: { color: "blue" },
                                attrs: {
                                  "input-class": "form-control dateFromCreated",
                                  "monday-first": "",
                                  size: "sm",
                                  language: _vm.ru,
                                  placeholder: "С:"
                                },
                                on: {
                                  selected: function($event) {
                                    return _vm.selectStartRange($event)
                                  }
                                },
                                model: {
                                  value: _vm.range.startDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "startDate", $$v)
                                  },
                                  expression: "range.startDate"
                                }
                              }),
                              _vm._v(" "),
                              _c("datepicker", {
                                staticClass: "date dateRight",
                                staticStyle: { color: "blue" },
                                attrs: {
                                  "input-class": "form-control dateToCreated",
                                  "monday-first": "",
                                  size: "sm",
                                  language: _vm.ru,
                                  placeholder: "По:"
                                },
                                on: {
                                  selected: function($event) {
                                    return _vm.selectEndRange($event)
                                  }
                                },
                                model: {
                                  value: _vm.range.endDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.range, "endDate", $$v)
                                  },
                                  expression: "range.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2 mb-2" },
                [
                  _vm.isXl
                    ? _c(
                        "b-button-group",
                        {
                          key: _vm.dateRange,
                          staticClass: "filterComponent datePickerXl"
                        },
                        [
                          _c("date-range-picker", {
                            ref: "picker",
                            attrs: {
                              "locale-data": _vm.dateRangeLocalFormat,
                              opens: "center",
                              ranges: _vm.dateRanges
                            },
                            on: {
                              update: function($event) {
                                return _vm.selectSecondRange($event)
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "input",
                                  fn: function(picker) {
                                    return [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.secondDateRange.startDate
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm._f("formatDateRange")(
                                              _vm.secondDateRange.endDate
                                            )
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "header",
                                  fn: function(header) {
                                    return _c("div", { staticClass: "slot" }, [
                                      _c("h2", [
                                        _vm._v("Выбрать даты внесения данных")
                                      ])
                                    ])
                                  }
                                }
                              ],
                              null,
                              false,
                              3057112587
                            ),
                            model: {
                              value: _vm.secondDateRange,
                              callback: function($$v) {
                                _vm.secondDateRange = $$v
                              },
                              expression: "secondDateRange"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            { attrs: { size: "sm", variant: "success" } },
                            [
                              _c("i", {
                                staticClass: "icon-fa icon-fa-calendar-check-o"
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isXl
                    ? _c(
                        "b-input-group",
                        { key: _vm.dateRange, staticClass: "filterComponent" },
                        [
                          _c("div"),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c("datepicker", {
                                staticClass: "date dateLeft",
                                staticStyle: { color: "green" },
                                attrs: {
                                  "input-class": "form-control dateFrom",
                                  size: "sm",
                                  "monday-first": "",
                                  language: _vm.ru,
                                  placeholder: "С:"
                                },
                                on: {
                                  selected: function($event) {
                                    return _vm.selectSecondStartRange($event)
                                  }
                                },
                                model: {
                                  value: _vm.secondDateRange.startDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.secondDateRange,
                                      "startDate",
                                      $$v
                                    )
                                  },
                                  expression: "secondDateRange.startDate"
                                }
                              }),
                              _vm._v(" "),
                              _c("datepicker", {
                                staticClass: "date dateRight",
                                staticStyle: { color: "green" },
                                attrs: {
                                  "input-class": "form-control dateTo",
                                  size: "sm",
                                  "monday-first": "",
                                  language: _vm.ru,
                                  placeholder: "По:"
                                },
                                on: {
                                  selected: function($event) {
                                    return _vm.selectSecondEndRange($event)
                                  }
                                },
                                model: {
                                  value: _vm.secondDateRange.endDate,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.secondDateRange,
                                      "endDate",
                                      $$v
                                    )
                                  },
                                  expression: "secondDateRange.endDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mb-2 mainButton",
                      class: _vm.showCollapse2 ? "collapsed" : null,
                      attrs: {
                        variant: "outline-success",
                        size: "sm",
                        "aria-expanded": _vm.showCollapse2 ? "true" : "false",
                        "aria-controls": "collapse-3"
                      },
                      on: {
                        click: function($event) {
                          return _vm.onClick()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    Фильтры\n                    "
                      ),
                      _vm.showCollapse2
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-minus" })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showCollapse2
                        ? _c("span", [
                            _c("i", { staticClass: "icon-fa icon-fa-plus" })
                          ])
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-sm-5 col-md-3 col-lg-3 col-xl-2 mb-2 applyButton"
                },
                [
                  _c(
                    "b-input-group",
                    { staticClass: "filterComponent" },
                    [
                      _c("div"),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "mainButton filterComponent",
                              staticStyle: {
                                "margin-right": "4px",
                                "border-top-left-radius": "0.2rem",
                                "border-bottom-left-radius": "0.2rem"
                              },
                              attrs: {
                                size: "sm",
                                text: "Search",
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.getData(1, null)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                            Применить\n                            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "mainButton filterComponent",
                              attrs: { size: "sm", variant: "outline-danger" },
                              on: { click: _vm.resetFilters }
                            },
                            [_vm._v("Очистить\n                            ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "b-collapse",
              {
                staticClass: "mt-2",
                attrs: { id: "collapse-2" },
                model: {
                  value: _vm.showCollapse2,
                  callback: function($$v) {
                    _vm.showCollapse2 = $$v
                  },
                  expression: "showCollapse2"
                }
              },
              [
                _c("b-card", [
                  _c("div", { staticClass: "row mb-2" }, [
                    _vm.$currentUser.role == "admin" ||
                    _vm.$currentUser.role == "leader"
                      ? _c(
                          "div",
                          { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                          [
                            _c(
                              "v-select",
                              {
                                attrs: {
                                  label: "name",
                                  options: _vm.users,
                                  required: "",
                                  placeholder: "Медиабайер",
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.user,
                                  callback: function($$v) {
                                    _vm.user = $$v
                                  },
                                  expression: "user"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "no-options" },
                                    slot: "no-options"
                                  },
                                  [_vm._v("Совпадений не найдено.")]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.selectOffers,
                              filter: _vm.filterOffers,
                              required: "",
                              label: "title",
                              placeholder: "Оффер",
                              multiple: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          "(" +
                                            _vm._s(option.id) +
                                            ") " +
                                            _vm._s(option.title)
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1477995661
                            ),
                            model: {
                              value: _vm.search,
                              callback: function($$v) {
                                _vm.search = $$v
                              },
                              expression: "search"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v("Совпадений не найдено.")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.sources,
                              filter: _vm.filterSources,
                              required: "",
                              label: "title",
                              placeholder: "Источник",
                              multiple: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "option",
                                  fn: function(option) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          "(" +
                                            _vm._s(option.id) +
                                            ") " +
                                            _vm._s(option.title)
                                        )
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1477995661
                            ),
                            model: {
                              value: _vm.source,
                              callback: function($$v) {
                                _vm.source = $$v
                              },
                              expression: "source"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                attrs: { slot: "no-options" },
                                slot: "no-options"
                              },
                              [_vm._v("Совпадений не найдено.")]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.types,
                            placeholder: "Тип",
                            clearable: false,
                            searchable: false
                          },
                          model: {
                            value: _vm.type,
                            callback: function($$v) {
                              _vm.type = $$v
                            },
                            expression: "type"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.isTestOptions,
                            searchable: false,
                            clearable: false,
                            placeholder: "Тест"
                          },
                          model: {
                            value: _vm.isTest,
                            callback: function($$v) {
                              _vm.isTest = $$v
                            },
                            expression: "isTest"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c("b-form-input", {
                          staticClass: "insertInput",
                          staticStyle: { height: "35px" },
                          attrs: { type: "text", placeholder: "Subid-1" },
                          model: {
                            value: _vm.selectedSub1,
                            callback: function($$v) {
                              _vm.selectedSub1 = $$v
                            },
                            expression: "selectedSub1"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c("b-form-input", {
                          staticClass: "insertInput",
                          staticStyle: { height: "35px" },
                          attrs: { type: "text", placeholder: "Subid-2" },
                          model: {
                            value: _vm.selectedSub2,
                            callback: function($$v) {
                              _vm.selectedSub2 = $$v
                            },
                            expression: "selectedSub2"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c("b-form-input", {
                          staticClass: "insertInput",
                          staticStyle: { height: "35px" },
                          attrs: { type: "text", placeholder: "Subid-3" },
                          model: {
                            value: _vm.selectedSub3,
                            callback: function($$v) {
                              _vm.selectedSub3 = $$v
                            },
                            expression: "selectedSub3"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.sub4Options,
                            placeholder: "Subid-4",
                            label: "text",
                            clearable: false,
                            searchable: false
                          },
                          model: {
                            value: _vm.selectedSub4,
                            callback: function($$v) {
                              _vm.selectedSub4 = $$v
                            },
                            expression: "selectedSub4"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-4 col-sm-6 mb-2" },
                      [
                        _c("b-form-input", {
                          staticClass: "insertInput",
                          staticStyle: { height: "35px" },
                          attrs: { type: "text", placeholder: "ID партнёра" },
                          model: {
                            value: _vm.selectedPartnerId,
                            callback: function($$v) {
                              _vm.selectedPartnerId = $$v
                            },
                            expression: "selectedPartnerId"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _vm.isTableAdded && !_vm.isMobile
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-info",
                        attrs: { role: "alert" }
                      },
                      [
                        _c("h5", [_vm._v("Правила добавления данных:")]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "Расход можно вносить в соответствии с датой внесения/изменения расхода в данных: "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.settings.expense_edit_date
                                )
                              )
                            )
                          ]),
                          _vm._v(
                            ". Если необходимо внести иные данные до этой даты, выставьте в этом поле 0"
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "Ставку можно вносить в соответствии с датой внесения/изменения дохода в данных: "
                          ),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDate")(
                                  _vm.settings.revenue_edit_date
                                )
                              )
                            )
                          ]),
                          _vm._v(
                            ". Если необходимо внести иные данные до этой даты, выставьте в этом поле 0"
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-12 insertTable" },
                    [
                      _c("b-table", {
                        staticClass: "insertTable",
                        attrs: {
                          responsive: "",
                          bordered: "",
                          small: "",
                          "head-variant": "light",
                          fixed: "",
                          items: _vm.newData,
                          fields: _vm.editingFields,
                          "no-local-sorting": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(date)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "40px",
                                        cursor: "pointer"
                                      },
                                      attrs: { id: "datePopover" + row.index }
                                    },
                                    [
                                      row.item.date
                                        ? _c(
                                            "span",
                                            { staticClass: "offersTitle" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDate")(
                                                      row.item.date
                                                    )
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      ref: "datePopover",
                                      attrs: {
                                        "custom-class": "datePopover",
                                        delay: { show: 50, hide: 200 },
                                        target: "datePopover" + row.index,
                                        triggers: "click blur"
                                      }
                                    },
                                    [
                                      _c("datepicker", {
                                        staticClass: "date",
                                        attrs: {
                                          "input-class": "form-control",
                                          "monday-first": "",
                                          inline: true,
                                          language: _vm.ru,
                                          placeholder: ""
                                        },
                                        on: { selected: _vm.onDateChange },
                                        model: {
                                          value: row.item.date,
                                          callback: function($$v) {
                                            _vm.$set(row.item, "date", $$v)
                                          },
                                          expression: "row.item.date"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(offer_id)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "40px",
                                        cursor: "pointer"
                                      },
                                      attrs: { id: "offersPopover" + row.index }
                                    },
                                    [
                                      row.item.offer_id
                                        ? _c(
                                            "span",
                                            { staticClass: "offersTitle" },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(row.item.offer_id.id) +
                                                  ") " +
                                                  _vm._s(
                                                    row.item.offer_id.title
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        placement: "topright",
                                        "custom-class": "offersPopover",
                                        delay: { show: 50, hide: 200 },
                                        target: "offersPopover" + row.index,
                                        triggers: "click blur"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-select",
                                        {
                                          staticClass: "insertInput",
                                          attrs: {
                                            options: _vm.options,
                                            filterable: false
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.onOfferChange(row)
                                            },
                                            search: _vm.onSearch
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "option",
                                                fn: function(option) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "d-center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(option.id) +
                                                            "\n                                        " +
                                                            _vm._s(
                                                              option.title
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "selected-option",
                                                fn: function(option) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "selected d-center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        (" +
                                                            _vm._s(option.id) +
                                                            ")\n                                        " +
                                                            _vm._s(
                                                              option.title
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: row.item.offer_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                row.item,
                                                "offer_id",
                                                $$v
                                              )
                                            },
                                            expression: "row.item.offer_id"
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "no-options" },
                                            [
                                              _vm._v(
                                                "\n                                    Введите символы...\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(application_owner)",
                              fn: function(row) {
                                return [
                                  _c("b-form-select", {
                                    attrs: {
                                      size: "sm",
                                      options: _vm.applicationOwnerOptions
                                    },
                                    model: {
                                      value: row.item.application_owner,
                                      callback: function($$v) {
                                        _vm.$set(
                                          row.item,
                                          "application_owner",
                                          $$v
                                        )
                                      },
                                      expression: "row.item.application_owner"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(is_test)",
                              fn: function(row) {
                                return [
                                  _c("b-form-checkbox", {
                                    attrs: {
                                      value: "1",
                                      "unchecked-value": "0"
                                    },
                                    model: {
                                      value: row.item.is_test,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "is_test", $$v)
                                      },
                                      expression: "row.item.is_test"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(sub1)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "text" },
                                    model: {
                                      value: row.item.sub1,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "sub1", $$v)
                                      },
                                      expression: "row.item.sub1"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(partner_id)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "number" },
                                    model: {
                                      value: row.item.partner_id,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "partner_id", $$v)
                                      },
                                      expression: "row.item.partner_id"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(sub2)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "text" },
                                    model: {
                                      value: row.item.sub2,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "sub2", $$v)
                                      },
                                      expression: "row.item.sub2"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(sub3)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "text" },
                                    model: {
                                      value: row.item.sub3,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "sub3", $$v)
                                      },
                                      expression: "row.item.sub3"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(sub4)",
                              fn: function(row) {
                                return [
                                  _c("b-form-select", {
                                    attrs: {
                                      size: "sm",
                                      options: _vm.sub4Options
                                    },
                                    model: {
                                      value: row.item.sub4,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "sub4", $$v)
                                      },
                                      expression: "row.item.sub4"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(source_id)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "40px",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        id: "sourcesPopover" + row.index
                                      }
                                    },
                                    [
                                      row.item.source_id
                                        ? _c(
                                            "span",
                                            { staticClass: "offersTitle" },
                                            [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    row.item.source_id.id
                                                  ) +
                                                  ") " +
                                                  _vm._s(
                                                    row.item.source_id.title
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        placement: "topright",
                                        "custom-class": "offersPopover",
                                        delay: { show: 50, hide: 200 },
                                        target: "sourcesPopover" + row.index,
                                        triggers: "click blur"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-select",
                                        {
                                          staticClass: "insertInput",
                                          attrs: {
                                            options: _vm.sourcesOptions,
                                            filterable: false
                                          },
                                          on: {
                                            input: function($event) {
                                              return _vm.onSourceChange(row)
                                            },
                                            search: _vm.onSourcesSearch
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "option",
                                                fn: function(option) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "d-center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(option.id) +
                                                            "\n                                        " +
                                                            _vm._s(
                                                              option.title
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              },
                                              {
                                                key: "selected-option",
                                                fn: function(option) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "selected d-center"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                        " +
                                                            _vm._s(
                                                              option.title
                                                            ) +
                                                            "\n                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: row.item.source_id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                row.item,
                                                "source_id",
                                                $$v
                                              )
                                            },
                                            expression: "row.item.source_id"
                                          }
                                        },
                                        [
                                          _c(
                                            "template",
                                            { slot: "no-options" },
                                            [
                                              _vm._v(
                                                "\n                                    Введите символы...\n                                "
                                              )
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(expense)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "number", step: "any" },
                                    model: {
                                      value: row.item.expense,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "expense", $$v)
                                      },
                                      expression: "row.item.expense"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(expense_rate)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "number", step: "any" },
                                    model: {
                                      value: row.item.expense_rate,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "expense_rate", $$v)
                                      },
                                      expression: "row.item.expense_rate"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(discount)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: {
                                      min: "0",
                                      max: "100",
                                      type: "number",
                                      step: "any"
                                    },
                                    model: {
                                      value: row.item.discount,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "discount", $$v)
                                      },
                                      expression: "row.item.discount"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(expense_currency)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "40px",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        id: "expenseCurrencyPopover" + row.index
                                      }
                                    },
                                    [
                                      row.item.expense_currency
                                        ? _c(
                                            "span",
                                            { staticClass: "offersTitle" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.item.expense_currency
                                                  )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        placement: "topright",
                                        "custom-class": "offersPopover",
                                        delay: { show: 50, hide: 200 },
                                        target:
                                          "expenseCurrencyPopover" + row.index,
                                        triggers: "click blur"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-select",
                                        {
                                          staticClass: "insertInput",
                                          attrs: { options: _vm.currency },
                                          model: {
                                            value: row.item.expense_currency,
                                            callback: function($$v) {
                                              _vm.$set(
                                                row.item,
                                                "expense_currency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "row.item.expense_currency"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "no-options" },
                                              slot: "no-options"
                                            },
                                            [_vm._v("Совпадений не найдено.")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(leads_count)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "number" },
                                    model: {
                                      value: row.item.leads_count,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "leads_count", $$v)
                                      },
                                      expression: "row.item.leads_count"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(lead_rate)",
                              fn: function(row) {
                                return [
                                  _c("b-form-input", {
                                    staticClass: "insertInput",
                                    attrs: { type: "number", step: "any" },
                                    model: {
                                      value: row.item.lead_rate,
                                      callback: function($$v) {
                                        _vm.$set(row.item, "lead_rate", $$v)
                                      },
                                      expression: "row.item.lead_rate"
                                    }
                                  })
                                ]
                              }
                            },
                            {
                              key: "cell(lead_currency)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        height: "40px",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        id: "leadCurrencyPopover" + row.index
                                      }
                                    },
                                    [
                                      row.item.lead_currency
                                        ? _c(
                                            "span",
                                            { staticClass: "offersTitle" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(row.item.lead_currency)
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        placement: "topright",
                                        "custom-class": "offersPopover",
                                        delay: { show: 50, hide: 200 },
                                        target:
                                          "leadCurrencyPopover" + row.index,
                                        triggers: "click blur"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-select",
                                        {
                                          staticClass: "insertInput",
                                          attrs: { options: _vm.currency },
                                          model: {
                                            value: row.item.lead_currency,
                                            callback: function($$v) {
                                              _vm.$set(
                                                row.item,
                                                "lead_currency",
                                                $$v
                                              )
                                            },
                                            expression: "row.item.lead_currency"
                                          }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              attrs: { slot: "no-options" },
                                              slot: "no-options"
                                            },
                                            [_vm._v("Совпадений не найдено.")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(actions)",
                              fn: function(row) {
                                return [
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-copy",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.copyRow(row.item)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "icon-fa icon-fa-trash-o",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.deleteRow(row.item)
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2662872326
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isTableAdded && !_vm.isMobile
                    ? _c(
                        "div",
                        { staticClass: "col-lg-12 mb-2" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "ml-2",
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.addRow()
                                }
                              }
                            },
                            [_vm._v("Добавить")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "ml-2",
                              attrs: { variant: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.save()
                                }
                              }
                            },
                            [_vm._v("Сохранить")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "ml-2",
                              attrs: { variant: "danger" },
                              on: {
                                click: function($event) {
                                  return _vm.resetAll()
                                }
                              }
                            },
                            [_vm._v("Отмена")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                !_vm.isMobile
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          ref: "selectableTable",
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            small: "",
                            items: _vm.dataArray,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            selectable: "",
                            "select-mode": _vm.selectMode,
                            "selected-variant": "active",
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getData(1, $event)
                            },
                            "row-selected": _vm.onRowSelected,
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(date)",
                                fn: function(row) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(row.item.date)
                                        )
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(is_test)",
                                fn: function(row) {
                                  return [
                                    row.item.is_test == "0"
                                      ? _c("div", [_vm._v("Нет")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.is_test == "1"
                                      ? _c("div", [_vm._v("Да")])
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(partner_id)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.partner_id))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm._f("formatPlatform")(
                                              row.item.offer.affise_platform
                                            )
                                          ) +
                                          ")"
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(offer_id)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        "(" + _vm._s(row.item.offer.id) + ")"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.offer.title))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(application_owner)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getAppOwnerByValue(
                                            row.item.application_owner
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(source_id)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        "(" + _vm._s(row.item.source.id) + ")"
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.source.title))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(expense_with_discount)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(row.item.expense_with_discount)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.expense_currency))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(revenue)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.revenue))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.lead_currency))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(lead_rate)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.lead_rate))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.lead_currency))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    row.item.user_id == _vm.$currentUser.id ||
                                    _vm.$currentUser.role == "admin" ||
                                    _vm.$currentUser.role == "leader"
                                      ? _c(
                                          "div",
                                          [
                                            new Date(row.item.date) >=
                                              new Date(
                                                _vm.settings.edit_date
                                              ) ||
                                            new Date(row.item.date) >=
                                              new Date(
                                                _vm.settings.expense_edit_date
                                              ) ||
                                            new Date(row.item.date) >=
                                              new Date(
                                                _vm.settings.revenue_edit_date
                                              )
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-warning",
                                                    attrs: { size: "sm" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.edit(row)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-edit"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            new Date(row.item.date) >=
                                            new Date(_vm.settings.edit_date)
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger",
                                                    attrs: { size: "sm" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.deleteData(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-trash-o"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(created_at)",
                                fn: function(row) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(row.item.cdate)
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2368459409
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isMobile
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            stacked: "",
                            small: "",
                            items: _vm.dataArray,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": function($event) {
                              return _vm.getData(1, $event)
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(date)",
                                fn: function(row) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(row.item.date)
                                        )
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(partner_id)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.partner_id))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm._f("formatPlatform")(
                                              row.item.offer.affise_platform
                                            )
                                          ) +
                                          ")"
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(offer_id)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.offer.title))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "(" + _vm._s(row.item.offer_id) + ")"
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(source_id)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.source.title))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "(" + _vm._s(row.item.source_id) + ")"
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(application_owner)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getAppOwnerByValue(
                                            row.item.application_owner
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(expense_with_discount)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(row.item.expense_with_discount)
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.expense_currency))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(lead_rate)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.lead_rate))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.lead_currency))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(revenue)",
                                fn: function(row) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.revenue))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(row.item.lead_currency))
                                    ])
                                  ]
                                }
                              },
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    row.item.user_id == _vm.$currentUser.id ||
                                    _vm.$currentUser.role == "admin" ||
                                    _vm.$currentUser.role == "leader"
                                      ? _c(
                                          "div",
                                          [
                                            new Date(row.item.date) >=
                                              new Date(
                                                _vm.settings.edit_date
                                              ) ||
                                            new Date(row.item.date) >=
                                              new Date(
                                                _vm.settings.expense_edit_date
                                              ) ||
                                            new Date(row.item.date) >=
                                              new Date(
                                                _vm.settings.revenue_edit_date
                                              )
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-warning",
                                                    attrs: { size: "sm" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.edit(row)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-edit"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            new Date(row.item.date) >=
                                            new Date(_vm.settings.edit_date)
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger",
                                                    attrs: { size: "sm" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.deleteData(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "icon-fa icon-fa-trash-o"
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass: "btn btn-warning",
                                                attrs: { size: "sm" },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.copyRowInMobile(
                                                      row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-copy"
                                                })
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              },
                              {
                                key: "cell(created_at)",
                                fn: function(row) {
                                  return [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatDate")(row.item.cdate)
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            876705335
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-5" }, [
                _c(
                  "div",
                  { attrs: { role: "status", "aria-live": "polite" } },
                  [_vm._v("Всего записей: " + _vm._s(_vm.pager.total))]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-7" }, [
                _c("div", { staticClass: "float-right" }, [
                  _c("nav", { attrs: { "aria-label": "Page navigation" } }, [
                    _c(
                      "ul",
                      { staticClass: "pagination justify-content-center" },
                      [
                        _c("b-pagination", {
                          attrs: {
                            size: "sm",
                            "total-rows": _vm.pager.total,
                            "per-page": _vm.pager.per_page
                          },
                          on: {
                            change: function($event) {
                              return _vm.getData($event)
                            }
                          },
                          model: {
                            value: _vm.pager.current_page,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "current_page", $$v)
                            },
                            expression: "pager.current_page"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "dataCreateModal",
                attrs: {
                  id: "createData",
                  size: "md",
                  title: "Добавить данные",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideRowMobileModal }
              },
              [
                _c("CreateDataModal", {
                  attrs: {
                    applicationOwnerOptions: _vm.applicationOwnerOptions,
                    form: _vm.rowData
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "dataEditModal",
                attrs: {
                  id: "dataEditModal",
                  size: "md",
                  title: "Редактировать данные",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideModal }
              },
              [
                _c("EditDataModal", {
                  attrs: {
                    applicationOwnerOptions: _vm.applicationOwnerOptions,
                    form: _vm.selectedData
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "leadRateEditModal",
                attrs: {
                  id: "leadRateEditModal",
                  size: "md",
                  title: "Редактировать данные",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideModal }
              },
              [
                _c("MassUpdateDataModal", {
                  attrs: {
                    applicationOwnerOptions: _vm.applicationOwnerOptions,
                    selectedData: _vm.selected
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "uploadDataModal",
                attrs: {
                  id: "uploadDataModal",
                  "ok-disabled": !Boolean(_vm.uploadDataModal.file),
                  "ok-title": "Загрузить",
                  "cancel-title": "Отмена",
                  title: "Загрузить данные"
                },
                on: {
                  ok: _vm.uploadData,
                  hidden: function($event) {
                    _vm.uploadDataModal.file = null
                  }
                }
              },
              [
                _vm._l(_vm.uploadDataModal.errors, function(error) {
                  return _c("span", { staticClass: "alert-danger" }, [
                    _vm._v(_vm._s(error))
                  ])
                }),
                _vm._v(" "),
                _c(
                  "form",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Выберите файл или перенесите сюда" } },
                      [
                        _c("b-form-file", {
                          attrs: {
                            state: Boolean(_vm.uploadDataModal.file),
                            accept: ".xlsx, .xls",
                            size: "sm",
                            placeholder: "Файл не выбран",
                            "drop-placeholder": "Drop file here..."
                          },
                          model: {
                            value: _vm.uploadDataModal.file,
                            callback: function($$v) {
                              _vm.$set(_vm.uploadDataModal, "file", $$v)
                            },
                            expression: "uploadDataModal.file"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Данные")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f1ac22f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1ac22f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/Data.vue
// module id = 978
// module chunks = 0